import { getUser } from '../../store/selectors/user';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box, Tabs } from '@mui/material';
import getMessage from '../../utils/getMessage';
import { Fragment, useEffect, useState } from 'react';
import useUserSummaryPanel from './useUserSummaryPanel.hook';
import { fetchInitialHearingList, fetchMoreHearings } from '../../store/actions';
import { hearingShape } from '../../types';
import UserSummaryHearingListPanel from './UserSummaryHearingListPanel';
import UserVotedCommentListPanel from './UserVotedCommentListPanel';

export const StyledTabs = styled(Tabs)`
    .MuiTabs-flexContainer {
      flex-direction: column;
    }
`;

export const TabStyle = {
  flexGrow: 1,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',

};

const UserSummaryPanel = ({ user, fetchOwnHearingList, hearingLists }) => {

  const { tabs, params, getTabListByTabValue, isVotedCommentsLoading, fetchMoreVotedComments } = useUserSummaryPanel();
  const [value, setValue] = useState(tabs(user)[0].tabValue);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchOwnHearingList(params);
  }, []);

  useEffect(() => {
    setIsLoading(hearingLists.ownHearings.isFetching);
  }, [hearingLists.ownHearings.isFetching]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>
      <div>
        <h2><FormattedMessage id='userInfoSummary'/></h2>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <UserSummaryHearingListPanel header={getMessage('userMemberInHearing')} list={getTabListByTabValue('member', hearingLists?.ownHearings?.data)} />
          <UserSummaryHearingListPanel header={getMessage('userFacilitatorInHearing')} list={getTabListByTabValue('facilitator', hearingLists?.ownHearings?.data)} />
          <UserVotedCommentListPanel 
            header={getMessage('userVotedSectionComments')} 
            list={getTabListByTabValue('voted', hearingLists?.ownHearings?.data)} 
            fetchMore={fetchMoreVotedComments}
          />
          
        </Box>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: getUser(state),
  hearingLists: state.hearingLists,
});
const mapDispatchToProps = dispatch => ({
  fetchOwnHearingList: (params) =>
    dispatch(fetchInitialHearingList('ownHearings', '/v1/hearing/', params)),
  fetchMoreHearings: () => dispatch(fetchMoreHearings('ownHearings')),
});

UserSummaryPanel.propTypes = {
  user: PropTypes.object,
  fetchOwnHearingList: PropTypes.func,
  hearingLists: PropTypes.objectOf(
    PropTypes.shape({
      isFetching: PropTypes.bool,
      data: PropTypes.arrayOf(hearingShape),
    }),
  ),
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserSummaryPanel));